import React , {useEffect} from "react";
import { Helmet } from "react-helmet-async";
const Services = () => {


  return (
    <>
    <Helmet>
        <title>
          Services | Audit, AI Software & Mobile App Development | DSAP Solutions
        </title>

        <meta
          name="description"
          content="DSAP Solutions offers audit & inspection services, AI-driven software development, enterprise mobile app development, and risk advisory services."
        />

        <meta
          name="keywords"
          content="audit services, AI software development, mobile app development India, enterprise solutions, compliance audit"
        />
      </Helmet>

      {/* PAGE HERO */}
      <section className="hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>
            Comprehensive audit, compliance, advisory, and
            AI-driven digital solutions tailored for government
            and enterprise organisations.
          </p>
        </div>
      </section>

      {/* AUDIT SERVICES */}
      <section className="section">
        <div className="container">
          <h2>Audit, Inspection & Compliance</h2>

          <div className="grid">
            <div className="card">
              <h3>Audit & Inspection</h3>
              <ul>
                <li>NSDC / NSTC Centre Audits</li>
                <li>Government Program Verification</li>
                <li>Monitoring & Field Inspections</li>
                <li>Infrastructure & process verification</li>
              </ul>
            </div>

            <div className="card">
              <h3>Internal Audit & Compliance</h3>
              <ul>
                <li>Corporate internal audits</li>
                <li>Regulatory compliance assessments</li>
                <li>Operational risk audits</li>
                <li>Process & control effectiveness reviews</li>
              </ul>
            </div>

            <div className="card">
              <h3>Risk & Control Advisory</h3>
              <ul>
                <li>Risk identification & mitigation roadmaps</li>
                <li>Control framework evaluation</li>
                <li>Policy & SOP reviews</li>
                <li>Governance strengthening initiatives</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* AI & DIGITAL */}
      <section className="section light">
        <div className="container">
          <h2>AI-Driven Digital Engineering</h2>
          <p>
            Our digital solutions combine deep domain expertise
            with artificial intelligence to deliver intelligent,
            scalable, and secure systems.
          </p>

          <div className="grid">
            <div className="card">
              <h3>AI-Driven Software Development</h3>
              <p>
                Custom-built enterprise software platforms designed
                to automate processes, generate insights, and
                support data-driven decision-making.
              </p>
              <ul>
                <li>AI analytics & forecasting platforms</li>
                <li>Compliance & audit intelligence systems</li>
                <li>Custom ERP, MIS & dashboards</li>
                <li>Secure API & system integrations</li>
              </ul>
            </div>

            <div className="card">
              <h3>Mobile App Development</h3>
              <p>
                Robust mobile applications that enable real-time
                field operations, data capture, and enterprise mobility.
              </p>
              <ul>
                <li>Android & iOS apps</li>
                <li>Offline-first field inspection apps</li>
                <li>POS, inventory & workforce apps</li>
                <li>Secure authentication & role-based access</li>
              </ul>
            </div>

            <div className="card">
              <h3>AI Governance & Security</h3>
              <p>
                Responsible AI implementation with strong governance,
                transparency, and regulatory compliance.
              </p>
              <ul>
                <li>Explainable AI models</li>
                <li>Audit trails & data lineage</li>
                <li>Security & confidentiality controls</li>
                <li>Regulatory-aligned deployments</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section dark">
        <div className="container" style={{ textAlign: "center" }}>
          <h2>Engage With DSAP Solutions</h2>
          <p>
            Partner with an independent assurance and digital
            solutions provider that combines governance,
            intelligence, and execution excellence.
          </p>
        </div>
      </section>
    </>
  );
};

export default Services;
